import { toast } from 'sonner';
import { startTransition } from 'react';
import { useMutation } from '@apollo/client/react';

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { EscrowMembershipRoleEnum } from 'src/graphql/schema';
import { EscrowMembershipUpdateDocument } from 'src/graphql/actions/escrowMemberships/escrowMembershipUpdate.mutation';

import { roleOptions, roleOptionsDict } from '../model';
import { refetchEscrowMemberships } from '../api';

const RoleCell = ({ role, id, canUpdate }: { role: string; id: string; canUpdate: boolean }) => {
  const [updateEscrowMembership, { loading }] = useMutation(EscrowMembershipUpdateDocument);

  const onUpdate = async (role: EscrowMembershipRoleEnum) => {
    try {
      await updateEscrowMembership({
        variables: {
          input: {
            escrowMembershipId: id,
            escrowMembershipParams: {
              role,
            },
          },
        },
      });
      toast.success('Member access has been updated');
      startTransition(() => refetchEscrowMemberships());
    } catch {
      toast.error('Failed to update member access');
    }
  };

  if (canUpdate) {
    return (
      <Select value={role} onValueChange={onUpdate}>
        <SelectTrigger
          variant="ghost"
          justify="end"
          disabled={loading}
          className="border-solid border border-transparent hover:border-border"
        >
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {roleOptions.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    );
  }

  return (
    <span className="block text-xs text-muted-foreground text-right">
      {roleOptionsDict[role as EscrowMembershipRoleEnum]}
    </span>
  );
};

export default RoleCell;
